(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["estudios-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('mdr-estudios');
  if (!root) return;

  /* ---------- Substance tab filter ---------- */
  var tabs = root.querySelectorAll('.est-substance-tab');
  var groups = root.querySelectorAll('.est-product-group');

  var allGrid = root.querySelector('.est-all-grid');
  var productNames = {
    'lipofast': 'Lipofast', 'lipoabs': 'Lipoabs', 'lipodrain': 'Lipodrain',
    'lipofirm': 'Lipofirm', 'liposculpt': 'Liposculpt', 'lipovax': 'Lipovax',
    'peptonas': 'Peptonas', 'lipoenzimas': 'Lipoenzimas Premium',
    'prdn': 'PRDN Advance', 'exoskin': 'Exoskin 360',
    'ultratensor': 'Ultratensor', 'gluteoperfect': 'Gluteo Perfect Plus'
  };

  /* Create product badges inside each card (shown only in Todos view) */
  groups.forEach(function (g) {
    var gName = g.getAttribute('data-group');
    var card = g.querySelector('.est-study-card');
    if (card && !card.querySelector('.est-study-product-badge')) {
      var badge = document.createElement('div');
      badge.className = 'est-study-product-badge';
      badge.textContent = productNames[gName] || gName;
      card.prepend(badge);
    }
  });

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var substance = tab.getAttribute('data-substance');

      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-pressed', 'true');

      groups.forEach(function (g) { g.classList.remove('is-active'); });

      if (substance === 'all') {
        groups.forEach(function (g) { g.classList.add('is-active'); });
        if (allGrid) allGrid.classList.add('is-unified');
      } else {
        if (allGrid) allGrid.classList.remove('is-unified');
        var target = root.querySelector('[data-group="' + substance + '"]');
        if (target) target.classList.add('is-active');
      }

      var area = document.getElementById('est-estudios');
      if (area) area.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Show all by default (unified view) */
  groups.forEach(function (g) { g.classList.add('is-active'); });

  /* ---------- Sticky nav shadow ---------- */
  var selectorWrap = root.querySelector('.est-selector-wrap');
  if (selectorWrap) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        selectorWrap.classList.toggle('is-scrolled', !e.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-1px 0px 0px 0px' });
    var hero = root.querySelector('.est-hero');
    if (hero) observer.observe(hero);
  }

  /* ---------- Lightbox for certificate images ---------- */
  var lb = root.querySelector('[data-lightbox]');
  var lbImg = lb && lb.querySelector('[data-lightbox-img]');

  function openLightbox(src, alt) {
    if (!lb || !lbImg) return;
    lbImg.src = src;
    lbImg.alt = alt || '';
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (lb) {
    root.querySelectorAll('[data-cert-img]').forEach(function (cert) {
      cert.addEventListener('click', function () {
        var img = cert.querySelector('img');
        if (img) openLightbox(img.src, img.alt);
      });
    });

    lb.addEventListener('click', function (e) {
      if (e.target === lbImg) return;
      closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLightbox();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
